/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {OBJECT_TYPE} from '../common/constants/object-type';

export function updateSearchQueryParams(paramObj: any, term: string): any {
  const params = {...paramObj};
  const words = (term || '').split(' ');
  params.q = term;

  if (words[0]) {
    const matchObj = _.find(OBJECT_TYPE, function(o) {
      return o.searchType && o.searchType + ':' === words[0];
    });

    if (matchObj) {
      params.types = matchObj.type;
      params.q = '';

      if (words.length > 1) {
        params.q = _.map(words.slice(1), function(w) {
          return w.trim();
        }).join(' ');
      }
    }
  }

  return params;
}
